export const state = {
	loader: false
}



// WEBPACK FOOTER //
// ./src/store/modules/Loader/state.js